import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import Button from "../../ui/molecoles/button";
import { Calendar } from "../../ui/molecoles/calendar";
import { InputComponent } from "../../ui/molecoles/input";
import { Spinner } from "../../ui/molecoles/spinner";
import { Switch } from "../../ui/molecoles/switch";
import { ModalComponent } from "../../ui/organisms/modal";
import { createReport, resetReportCreateRequest, setCreateReportRequestEndDate, setCreateReportRequestFlightIdent, setCreateReportRequestNotam, setCreateReportRequestStartDate, setOpenNewReportModal } from "./slice";


export function NewReportModal() {
    const reportState = useAppSelector(state => state.report)
    const dispatch = useAppDispatch()

    const [date, setDate] = useState<Date | null>(null);

    useEffect(() => {
        setDate(null)
        dispatch(resetReportCreateRequest())
    }, [reportState.openNewReportModal])

    useEffect(() => {
        if (date) {
            const startDate = new Date(Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                0, 0, 0
            ));

            const endDate = new Date(Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                23, 59, 0
            ));

            const formatToIsoZ = (d: Date) => d.toISOString().split('.')[0] + 'Z';

            dispatch(setCreateReportRequestStartDate(formatToIsoZ(startDate)));
            dispatch(setCreateReportRequestEndDate(formatToIsoZ(endDate)));
        }
    }, [date])

    return (
        <ModalComponent
            width="large"
            open={reportState.openNewReportModal}
            handleClose={() => {
                dispatch(setOpenNewReportModal(false));
            }}
        >
            <div
                className=" p-5 bg-white rounded-xl flex flex-col gap-2.5 w-full "
                style={{
                    boxShadow: '0px 12px 24px 0px rgba(22, 42, 100, 0.12)',
                }}
            >
                <div className="flex items-center justify-between">
                    <span className="text-heading-xs font-semibold text-pas-800">Create report</span>
                </div>
                <div className="flex flex-col items-start mb-1" style={{ gap: '16px', width: '100%' }}>
                    <InputComponent
                        label="Flight ident"
                        placeholder="Flight ident"
                        type={"text"}
                        defaultValue={reportState.createReportRequest.flight_ident}
                        onChangeText={(value) => {
                            const noSpaces = value.replace(/\s+/g, '');
                            const match = noSpaces.match(/^([A-Za-z0-9]{2})(0*)(\d+)$/);

                            if (match) {
                                const prefix = match[1];
                                const number = match[3];
                                dispatch(setCreateReportRequestFlightIdent(prefix.toUpperCase() + number));
                            } else {
                                dispatch(setCreateReportRequestFlightIdent(noSpaces.toUpperCase()));
                            }
                        }}
                        required
                        disabled={reportState.createReportStatus === "loading"}
                    />
                    <Calendar
                        label="Date"
                        startDate={date}
                        setStartDate={(date: Date | null) => setDate(date)}
                        type={"date"}
                        required
                        disabled={reportState.createReportStatus === "loading"}
                    />
                    {/* <Switch
                        label="Notam"
                        checked={reportState.createReportRequest.with_notamify}
                        onChange={(e) => dispatch(setCreateReportRequestNotam(e))}
                        disabled={reportState.createReportStatus === "loading"}
                    /> */}
                    {/* <div className="w-full flex flex-row gap-4">
                        <InputComponent
                            label="Nome"
                            placeholder="Nome"
                            type={"text"}
                            defaultValue={reportState.createReportRequest.user_info.first_name}
                            onChangeText={(value) => dispatch(setCreateReportRequestFirstName(value))}
                        />
                        <InputComponent
                            label="Cognome"
                            placeholder="Cognome"
                            type={"text"}
                            defaultValue={reportState.createReportRequest.user_info.last_name}
                            onChangeText={(value) => dispatch(setCreateReportRequestLastName(value))}
                        />
                    </div>
                    <div className="w-full flex flex-row gap-4">
                        <InputComponent
                            label="Email"
                            placeholder="Email"
                            type={"text"}
                            startIcon={<EmailIcon size={20} color={colors.neutral[400]} />}
                            defaultValue={reportState.createReportRequest.user_info.email}
                            value={reportState.createReportRequest.user_info.email?.toLowerCase()}
                            onChangeText={(value) => dispatch(setCreateReportRequestEmail(value.toLowerCase()))}
                        />
                        <InputComponent
                            startIcon={
                                <div className=" flex flex-row items-center">
                                    <span className=" text-text-sm font-medium text-neutral-400">+39</span>
                                </div>
                            }
                            label="Telefono"
                            placeholder="Telefono"
                            type={"text"}
                            defaultValue={reportState.createReportRequest.user_info.phone}
                            onChangeText={(value) => dispatch(setCreateReportRequestPhone(value))}
                        />
                    </div> */}
                </div>
                {
                    reportState.createReportStatus === "loading" ?
                        <div className={"w-full flex items-center justify-center"}>
                            <Spinner size={30} />
                        </div>
                        :
                        <div className={"flex gap-3 items-center justify-center"}>
                            <Button
                                label={"Cancel"}
                                onClick={() => {
                                    dispatch(setOpenNewReportModal(false))
                                }}
                                color={"gray"}
                                variant={"outline"}
                                size={"sm"}
                                iconPosition="off"
                                fullWidth
                            />
                            <Button
                                label={"Create report"}
                                onClick={() => dispatch(createReport(reportState.createReportRequest))}
                                color={"blue"}
                                variant={"solid"}
                                size={"sm"}
                                iconPosition="off"
                                fullWidth
                                disabled={reportState.createReportRequest.flight_ident === "" || date === null}
                            />
                        </div>
                }
            </div>
        </ModalComponent >
    )
}